/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PickList0101Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const pickList0101ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const pickList0101FetchPickList0101Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const pickList0101FetchPickList0101Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const pickList0101AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const pickList0101RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const pickList0101SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const pickList0101PrintPickList0101Loading = (state, { boolean }) => ({
  ...state,
  printIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PickList0101Types.PICK_LIST0101_RESET_TIMESTAMP]: pickList0101ResetTimestamp,
  [PickList0101Types.PICK_LIST0101_FETCH_PICK_LIST0101_LOADING]: pickList0101FetchPickList0101Loading,
  [PickList0101Types.PICK_LIST0101_FETCH_PICK_LIST0101_SUCCESS]: pickList0101FetchPickList0101Success,
  [PickList0101Types.PICK_LIST0101_ADD_SELECTED_DOCUMENTS]: pickList0101AddSelectedDocuments,
  [PickList0101Types.PICK_LIST0101_REMOVE_SELECTED_DOCUMENTS]: pickList0101RemoveSelectedDocuments,
  [PickList0101Types.PICK_LIST0101_SET_WORKSPACE_VISIBLE]: pickList0101SetWorkspaceVisible,
  [PickList0101Types.PICK_LIST0101_PRINT_PICK_LIST0101_LOADING]: pickList0101PrintPickList0101Loading
});
